/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useState} from 'react'
import {PageTitle} from '../../../../_metronic/layout/core'
import {Datatable} from '../../../components/Datatable/Datatable'
import {Button} from '../../../components/Button/Button'
import {useLocation, useSearchParams} from 'react-router-dom'
import {GET, GET_ADM, POST, PUT, DELETE} from '../../../services/api'
import {toDate} from '../../../utils/formater'
import {Loading} from '../../../components/Loading/Loading'
import Swal from 'sweetalert2'
import {i18n} from '../../../translate/i18n'
import {BreadCrumbs} from '../../../components/BreadCrumbs/breadCrumbrs'
import {Input} from '../../../components/Input/Input'
import {Modal} from 'react-bootstrap'
import styles from './translatePluginspace.module.css'

type StoreType = {
  id: number
  name: string
  type: string
  subdomain: string
  status: string
  active: boolean
  created: Date
  cnpj: string
  languages?: TranslateLanguage[]
}

type TranslateLanguage = {
  code: string
  name: string
  status: boolean
  description: string
}

type StoreRelation = {
  pluginspaceId: number
  child: number
  parentStore?: StoreType
  childStore?: StoreType
  created?: Date | string
  updated?: Date | string
  parentName?: string
  childName?: string
  parentSubdomain?: string
  childSubdomain?: string
}

const TranslatePluginspaceContent: FC = () => {
  const _location = useLocation()
  const [searchParams] = useSearchParams()

  // Estado para controlar as abas
  const [activeTab, setActiveTab] = useState('translations')

  // Opções de status
  const statusOptions = [
    {
      value: 1,
      select: i18n.t('translate_stores.status_options.active'),
    },
    {
      value: 0,
      select: i18n.t('translate_stores.status_options.inactive'),
    },
    {
      value: 2,
      select: i18n.t('translate_stores.status_options.both'),
    },
  ]

  // Estados de filtros
  const [filterStatus, setFilterStatus] = useState<any>(() => {
    const savedItem = localStorage.getItem(_location.pathname)
    const storeRecuperado = savedItem ? JSON.parse(savedItem) : null
    const statusFromLocalStorage = storeRecuperado ? storeRecuperado.status : null
    const res = statusFromLocalStorage || searchParams.get('status')
    const status = statusOptions.find((option) => option.select === res)
    return status
      ? {label: status.select, value: status.value}
      : {label: i18n.t('translate_stores.status_options.active'), value: 1}
  })

  const [filterType, setFilterType] = useState<any>({
    label: i18n.t('translate_stores.status_options.all_types'),
    value: 0,
  })

  // Estados da aplicação
  const [data, setData] = useState<StoreType[]>([])
  const [dataAll, setDataAll] = useState<StoreType[]>([])
  const [loading, setLoading] = useState(false)
  const [loadingTable, setLoadingTable] = useState(false)
  const [optionsFilter, setOptionsFilter] = useState<any>([])

  // Estados do modal de linguagens
  const [showLanguageModal, setShowLanguageModal] = useState(false)
  const [selectedStoreId, setSelectedStoreId] = useState<number>(0)
  const [selectedStoreName, setSelectedStoreName] = useState<string>('')
  const [storeLanguages, setStoreLanguages] = useState<TranslateLanguage[]>([])
  const availableLanguages: TranslateLanguage[] = [
    {
      code: 'pt',
      description: i18n.t('translate_stores.languages.portuguese'),
      name: 'PT',
      status: false,
    },
    {
      code: 'es',
      description: i18n.t('translate_stores.languages.spanish'),
      name: 'ES',
      status: false,
    },
    {
      code: 'en',
      description: i18n.t('translate_stores.languages.english'),
      name: 'EN',
      status: false,
    },
    {
      code: 'fr',
      description: i18n.t('translate_stores.languages.french'),
      name: 'FR',
      status: false,
    },
    {
      code: 'de',
      description: i18n.t('translate_stores.languages.german'),
      name: 'DE',
      status: false,
    },
    {
      code: 'it',
      description: i18n.t('translate_stores.languages.italian'),
      name: 'IT',
      status: false,
    },
    {
      code: 'ja',
      description: i18n.t('translate_stores.languages.japanese'),
      name: 'JA',
      status: false,
    },
    {
      code: 'ko',
      description: i18n.t('translate_stores.languages.korean'),
      name: 'KO',
      status: false,
    },
    {
      code: 'zh',
      description: i18n.t('translate_stores.languages.chinese'),
      name: 'ZH',
      status: false,
    },
  ]

  // Estados para relacionamentos de lojas
  const [storeRelations, setStoreRelations] = useState<StoreRelation[]>([])
  const [showRelationModal, setShowRelationModal] = useState(false)
  const [selectedParentStore, setSelectedParentStore] = useState<any>(null)
  const [selectedChildStore, setSelectedChildStore] = useState<any>(null)
  const [loadingRelations, setLoadingRelations] = useState(false)
  const [relationModalMode, setRelationModalMode] = useState<'create' | 'edit'>('create')
  const [editingRelation, setEditingRelation] = useState<StoreRelation | null>(null)

  // Estados dos filtros de relacionamentos
  const [filterParentStore, setFilterParentStore] = useState<any>({
    label: i18n.t('translate_stores.relations.all_option'),
    value: 0,
  })
  const [filterChildStore, setFilterChildStore] = useState<any>({
    label: i18n.t('translate_stores.relations.all_option'),
    value: 0,
  })
  function capitalize(str: any) {
    if (!str) return str
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
  }

  // Função para obter tipos únicos
  const getUniqueTypes = async (data: any) => {
    const uniqueTypes: any = []
    let index = 1

    data.forEach((item: any) => {
      if (
        item.type &&
        !uniqueTypes.some((obj: any) => obj.select.toLowerCase() === item.type.toLowerCase())
      ) {
        const selectCapitalize = capitalize(item.type)
        uniqueTypes.push({select: selectCapitalize, value: index++})
      }
    })

    const newUniqueTypes = [
      {select: i18n.t('translate_stores.status_options.all_types'), value: 0},
      ...uniqueTypes,
    ]
    setOptionsFilter(newUniqueTypes)
    return
  }

  // Função para buscar dados das lojas
  const getData = async () => {
    setLoading(true)
    setLoadingTable(true)

    try {
      const res = await GET_ADM(`/pluginspace`)
      const _data = res.data.map((item: StoreType) => {
        return {
          id: item.id,
          name: item.name,
          subdomain: item.subdomain,
          type: item.type,
          status: item.status
            ? i18n.t('translate_stores.table.status.active')
            : i18n.t('translate_stores.table.status.inactive'),
          created: toDate(item.created.toString()),
          cnpj: item.cnpj ? item.cnpj : '',
          languages: item.languages || [],
        }
      })

      setData(_data)
      setDataAll(_data)
      await getUniqueTypes(_data)

      setLoading(false)
      setLoadingTable(false)
    } catch (e) {
      setData([])
      setLoading(false)
      setLoadingTable(false)
      console.log(e)
      Swal.fire({
        icon: 'error',
        title: i18n.t('translate_stores.messages.error.title').toString(),
        text: i18n.t('translate_stores.messages.error.load_data').toString(),
      })
    }
  }

  // Função para filtrar lojas
  const filterStores = async () => {
    try {
      setLoading(true)
      setLoadingTable(true)

      const newFilterType =
        filterType.value === 0
          ? dataAll
          : dataAll.filter((data: any) => data.type === filterType.label.toLowerCase())

      switch (filterStatus.value) {
        case 1:
          const newDataAtivo = newFilterType.filter((item: any) => item.status)
          setData(newDataAtivo)
          break
        case 2:
          setData(newFilterType)
          break
        case 0:
          const newDataInativo = newFilterType.filter((item: any) => !item.status)
          setData(newDataInativo)
          break
        default:
          setData(dataAll)
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
      setLoadingTable(false)
    }
  }

  // Função para abrir modal de linguagens
  const openLanguageModal = async (store: StoreType) => {
    setSelectedStoreId(store.id)
    setSelectedStoreName(store.name)

    try {
      setLoading(true)
      const res = await GET(`/hotel-translation/admin/${store.id}`)

      if (res.success && res.data.length > 0) {
        const mergedLanguages = [
          ...availableLanguages.map((lang) => {
            const found = res.data[0].languages.find((l: TranslateLanguage) => l.code === lang.code)
            return found ? {...lang, ...found} : lang
          }),
        ]
        // Remove duplicadas pelo code
        const uniqueLanguages = mergedLanguages.filter(
          (lang, idx, arr) => arr.findIndex((l) => l.code === lang.code) === idx
        )
        setStoreLanguages(uniqueLanguages)
      } else {
        setStoreLanguages([...availableLanguages])
      }

      setShowLanguageModal(true)
      setLoading(false)
    } catch (error) {
      setLoading(false)
      console.log(error)
      setStoreLanguages([...availableLanguages])
      setShowLanguageModal(true)
    }
  }

  // Função para atualizar status da linguagem
  const updateLanguageStatus = (code: string, status: boolean) => {
    const newLanguages = storeLanguages.map((lang) => {
      if (lang.code === code) {
        return {...lang, status}
      }
      return lang
    })
    setStoreLanguages(newLanguages)
  }

  // Função para salvar linguagens
  const saveStoreLanguages = async () => {
    try {
      setLoading(true)

      const res = await POST('/hotel-translation/admin', {
        pluginspaceId: selectedStoreId,
        languages: storeLanguages.filter((lang) => lang.status), // Envia apenas as linguagens ativas
      })

      if (res.success) {
        // Show success modal and when user confirms, close modal and force a hard reload
        Swal.fire({
          icon: 'success',
          title: i18n.t('translate_stores.messages.success.title').toString(),
          text: i18n.t('translate_stores.messages.success.save').toString(),
        }).then(() => {
          // Fecha o modal de linguagens
          setShowLanguageModal(false)
          // Faz um reload simples da página

          // `window.location.reload()` realiza um reload; se o cache for um problema,
          try {
            window.location.reload()
          } catch (e) {
            // Fallback simples
            // eslint-disable-next-line no-self-assign
            window.location.href = window.location.href
          }
        })
      } else {
        Swal.fire({
          icon: 'error',
          title: i18n.t('translate_stores.messages.error.title').toString(),
          text: i18n.t('translate_stores.messages.error.save_languages').toString(),
        })
      }

      setLoading(false)
    } catch (error) {
      setLoading(false)
      console.log(error)
      Swal.fire({
        icon: 'error',
        title: i18n.t('translate_stores.messages.error.title').toString(),
        text: i18n.t('translate_stores.messages.error.save_languages').toString(),
      })
    }
  }

  // Funções para gerenciar relacionamentos de lojas
  const getStoreRelations = async (parentFilter?: number, childFilter?: number) => {
    try {
      setLoadingRelations(true)

      // Prepara os parâmetros do POST
      const filters: any = {}
      if (parentFilter && parentFilter !== 0) {
        filters.pluginspaceId = parentFilter
      }
      if (childFilter && childFilter !== 0) {
        filters.child = childFilter
      }

      // Se há filtros, faz POST, senão faz GET
      let res
      if (Object.keys(filters).length > 0) {
        res = await POST('/store-relations/filter', filters)
      } else {
        res = await GET('/store-relations')
      }

      // Determina os dados baseado na estrutura da resposta
      let relationsData = []

      if (Array.isArray(res)) {
        // Resposta direta como array
        relationsData = res
      } else if (res && res.data && Array.isArray(res.data)) {
        // Resposta com estrutura {data: [...]}
        relationsData = res.data
      } else if (res && Array.isArray(res)) {
        // Fallback para outras estruturas
        relationsData = res
      }

      if (relationsData.length > 0) {
        const relationsWithStoreData = relationsData.map((relation: any) => {
          const parentStore = dataAll.find((store) => store.id === relation.pluginspaceId)
          const childStore = dataAll.find((store) => store.id === relation.child)

          return {
            ...relation,
            // Ensure a unique id for the Datatable (avoid items without id being collapsed)
            id: `${relation.pluginspaceId}-${relation.child}`,
            parentStore,
            childStore,
            parentName: parentStore?.name || `Loja ID ${relation.pluginspaceId}`,
            childName: childStore?.name || `Loja ID ${relation.child}`,
            // keep subdomain values meaningful when available
            parentId: parentStore?.id || '-',
            childId: childStore?.id || '-',
            parentSubdomain: parentStore?.subdomain || '-',
            childSubdomain: childStore?.subdomain || '-',
            created: relation.created || relation.updated,
          }
        })

        setStoreRelations(relationsWithStoreData)
      } else {
        console.log('Nenhum relacionamento encontrado')
        setStoreRelations([])
      }
    } catch (error) {
      console.error('Erro ao carregar relacionamentos:', error)
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: 'Erro ao carregar relacionamentos de lojas',
      })
      setStoreRelations([])
    } finally {
      setLoadingRelations(false)
    }
  }

  const openRelationModal = (mode: 'create' | 'edit' = 'create', relation?: StoreRelation) => {
    setRelationModalMode(mode)

    if (mode === 'edit' && relation) {
      setEditingRelation(relation)
      setSelectedParentStore({
        label: relation.parentStore?.name
          ? `${relation.parentStore.name} (${relation.parentStore.id})`
          : i18n.t('translate_stores.relations.store_not_found'),
        value: relation.pluginspaceId,
      })
      setSelectedChildStore({
        label: relation.childStore?.name
          ? `${relation.childStore.name} (${relation.childStore.id})`
          : i18n.t('translate_stores.relations.store_not_found'),
        value: relation.child,
      })
    } else {
      setEditingRelation(null)
      setSelectedParentStore(null)
      setSelectedChildStore(null)
    }

    setShowRelationModal(true)
  }

  const createStoreRelation = async () => {
    if (!selectedParentStore || !selectedChildStore) {
      Swal.fire({
        icon: 'warning',
        title: String(i18n.t('translate_stores.modal.alert.title')),
        text: `${String(i18n.t('translate_stores.relations.parent_missing'))} / ${String(
          i18n.t('translate_stores.relations.child_missing')
        )}`,
      })
      return
    }

    if (selectedParentStore.value === selectedChildStore.value) {
      Swal.fire({
        icon: 'warning',
        title: String(i18n.t('translate_stores.modal.alert.title')),
        text: String(i18n.t('translate_stores.relations.same_store_error')),
      })
      return
    }

    try {
      setLoading(true)

      const res = await POST('/store-relations', {
        pluginspaceId: selectedParentStore.value,
        child: selectedChildStore.value,
      })

      if (res.success) {
        Swal.fire({
          icon: 'success',
          title: String(i18n.t('translate_stores.messages.success.title')),
          text: String(i18n.t('translate_stores.relations.created_success')),
        })
        setShowRelationModal(false)
        // Recarrega relacionamentos com filtros atuais
        const parentId = filterParentStore.value !== 0 ? filterParentStore.value : undefined
        const childId = filterChildStore.value !== 0 ? filterChildStore.value : undefined
        await getStoreRelations(parentId, childId)
      } else {
        Swal.fire({
          icon: 'error',
          title: String(i18n.t('translate_stores.messages.error.title')),
          text: res.message || String(i18n.t('translate_stores.relations.error_create')),
        })
      }
    } catch (error: any) {
      console.log(error)
      Swal.fire({
        icon: 'error',
        title: String(i18n.t('translate_stores.messages.error.title')),
        text: error || String(i18n.t('translate_stores.relations.error_create')),
      })
    } finally {
      setLoading(false)
    }
  }

  const updateStoreRelation = async () => {
    if (!editingRelation || !selectedParentStore || !selectedChildStore) {
      return
    }

    try {
      setLoading(true)

      const res = await PUT(
        `/store-relations/${editingRelation.pluginspaceId}/${editingRelation.child}`,
        {
          pluginspaceId: selectedParentStore.value,
          child: selectedChildStore.value,
        }
      )

      if (res.success) {
        Swal.fire({
          icon: 'success',
          title: 'Sucesso',
          text: 'Relacionamento atualizado com sucesso',
        })
        setShowRelationModal(false)
        // Recarrega relacionamentos com filtros atuais
        const parentId = filterParentStore.value !== 0 ? filterParentStore.value : undefined
        const childId = filterChildStore.value !== 0 ? filterChildStore.value : undefined
        await getStoreRelations(parentId, childId)
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: 'Erro ao atualizar relacionamento',
        })
      }
    } catch (error) {
      console.log(error)
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: 'Erro ao atualizar relacionamento',
      })
    } finally {
      setLoading(false)
    }
  }

  const deleteStoreRelation = async (relation: StoreRelation) => {
    const result = await Swal.fire({
      title: String(i18n.t('translate_stores.modal.alert.title')),
      text: `${String(i18n.t('translate_stores.relations.message_delete'))} ${
        relation.parentStore?.name
      } - ${relation.childStore?.name}`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: String(i18n.t('translate_stores.relations.delete_confirm')),
      cancelButtonText: String(i18n.t('translate_stores.relations.cancel')),
    })

    if (result.isConfirmed) {
      try {
        setLoading(true)

        const res = await DELETE(`/store-relations/${relation.pluginspaceId}/${relation.child}`)

        if (res.success || res.status === 204) {
          Swal.fire({
            icon: 'success',
            title: 'Sucesso',
            text: String(i18n.t('translate_stores.relations.deleted_success')),
          })
          // Recarrega relacionamentos com filtros atuais
          const parentId = filterParentStore.value !== 0 ? filterParentStore.value : undefined
          const childId = filterChildStore.value !== 0 ? filterChildStore.value : undefined
          await getStoreRelations(parentId, childId)
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Erro',
            text: String(i18n.t('translate_stores.relations.error_delete')),
          })
        }
      } catch (error) {
        console.log(error)
        Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: String(error) || String(i18n.t('translate_stores.relations.error_delete')),
        })
      } finally {
        setLoading(false)
      }
    }
  }

  // Função para preparar opções de select para as lojas (agora mostra todas as lojas)
  const getStoreOptions = () => {
    if (!dataAll || dataAll.length === 0) {
      return []
    }

    return dataAll.map((store) => ({
      select: `${store.name} (${store.id})`,
      value: store.id,
    }))
  }

  // Função para preparar opções de filtro para relacionamentos
  const getStoreFilterOptions = () => {
    if (!dataAll || dataAll.length === 0) {
      return [{select: i18n.t('translate_stores.relations.all_option'), value: 0}]
    }

    const storeOptions = dataAll.map((store) => ({
      select: `${store.name} (${store.id})`,
      value: store.id,
    }))

    return [{select: i18n.t('translate_stores.relations.all_option'), value: 0}, ...storeOptions]
  }

  // Função para filtrar relacionamentos
  const filterRelations = async () => {
    try {
      setLoadingRelations(true)

      const parentId = filterParentStore.value !== 0 ? filterParentStore.value : undefined
      const childId = filterChildStore.value !== 0 ? filterChildStore.value : undefined

      await getStoreRelations(parentId, childId)
    } catch (error) {
      console.log(error)
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: 'Erro ao filtrar relacionamentos',
      })
    } finally {
      setLoadingRelations(false)
    }
  }

  // Função para determinar a classe da tab
  const getTabClass = (tabId: string, isActive: boolean) => {
    const baseClass = styles.tabItem

    // if (tabErrors[tabId]) {
    //   return `${baseClass} ${styles.tabError} ${isActive ? 'active' : ''}`
    // }

    return `${baseClass} ${isActive ? styles.tabActive : styles.tabInactive}`
  }

  useEffect(() => {
    getData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (activeTab === 'relations' && dataAll.length > 0) {
      // Carrega relacionamentos sem filtros na primeira vez
      getStoreRelations()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab, dataAll])

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className='row g-5 gx-xxl-12'>
          <div className='card card-xxl-stretch mb-5 mb-xl-12'>
            <div className='card-header py-5'>
              <h3 className='card-title align-items-start flex-column'>
                <span className='card-label fw-bolder fs-3 mb-1'>
                  {i18n.t('translate_stores.page_title')}
                </span>
                <BreadCrumbs />
                <span className='text-muted mt-1 fw-bold fs-7'>
                  {i18n.t('translate_stores.page_subtitle')}
                </span>
              </h3>
            </div>

            <div className='card-body'>
              {/* Navegação por abas - Estilo customizado */}
              <div className={`d-flex ${styles.tabMenu}`}>
                <div
                  className={getTabClass('translations', activeTab === 'translations')}
                  onClick={() => setActiveTab('translations')}
                >
                  <i className='fas fa-language me-2'></i>
                  {i18n.t('translate_stores.tab_translations')}
                </div>
                <div
                  className={getTabClass('relations', activeTab === 'relations')}
                  onClick={() => setActiveTab('relations')}
                >
                  <i className='fas fa-sitemap me-2'></i>
                  {i18n.t('translate_stores.tab_relations')}
                </div>
              </div>

              {/* Conteúdo das abas */}
              <div className={styles.tabContent}>
                {/* Aba de Traduções */}
                {activeTab === 'translations' && (
                  <div>
                    <div className='d-flex align-items-center justify-content-start'>
                      <div className='d-flex w-50 '>
                        <div className=' align-items-end  justify-content-start me-5 flex-grow-1'>
                          <span className='align-self-start'>
                            {i18n.t('translate_stores.filters.status')}
                          </span>
                          <Input
                            inputAttr={{
                              type: 'select',
                            }}
                            options={statusOptions}
                            value={filterStatus}
                            placeholder={i18n.t('translate_stores.filters.status_placeholder')}
                            search={true}
                            change={(value: any) => {
                              setFilterStatus(value)
                            }}
                          />
                        </div>
                        <div className=' align-items-end  justify-content-start me-5 flex-grow-1'>
                          <span className='align-self-start'>
                            {i18n.t('translate_stores.filters.type')}
                          </span>
                          <Input
                            inputAttr={{
                              type: 'select',
                            }}
                            options={optionsFilter}
                            value={filterType}
                            placeholder={i18n.t('translate_stores.filters.type_placeholder')}
                            search={true}
                            change={(value: any) => setFilterType(value)}
                          />
                        </div>
                      </div>

                      <div
                        className='d-flex align-items-end w-50 justify-content-end h-100'
                        style={{
                          marginTop: '48px',
                        }}
                      >
                        <Button
                          text={i18n.t('translate_stores.filters.filter_button')}
                          color='primary'
                          iconColor='#FFF'
                          icon='fas fa-filter'
                          size='small'
                          horizontalPadding={6}
                          btnAttr={{
                            type: 'button',
                          }}
                          click={async () => {
                            setLoading(true)
                            await filterStores()
                            setLoading(false)
                          }}
                          btnClass='mb-0 fw-bolder'
                        />
                      </div>
                    </div>

                    {loadingTable ? (
                      <Loading />
                    ) : (
                      <>
                        <Datatable
                          data={data}
                          headers={[
                            {
                              key: i18n.t('translate_stores.table.headers.type'),
                              value: 'type',
                              type: 'bullet',
                            },
                            {
                              key: i18n.t('translate_stores.table.headers.id'),
                              value: 'id',
                              type: 'default',
                            },
                            {
                              key: i18n.t('translate_stores.table.headers.name'),
                              value: 'name',
                              type: 'default',
                            },
                            {
                              key: i18n.t('translate_stores.table.headers.subdomain'),
                              value: 'subdomain',
                              type: 'default',
                            },
                            {
                              key: i18n.t('translate_stores.table.headers.status'),
                              value: 'status',
                              type: 'badge',
                              badge: {
                                ativo: 'success',
                                inativo: 'danger',
                              },
                            },
                            {
                              key: i18n.t('translate_stores.table.headers.created'),
                              value: 'created',
                              type: 'default',
                            },
                            {
                              key: i18n.t('translate_stores.table.headers.cnpj'),
                              value: 'cnpj',
                              type: 'cnpj',
                            },
                            {
                              key: i18n.t('translate_stores.table.headers.actions'),
                              value: 'acoes',
                              type: '',
                            },
                          ]}
                          options={[
                            {
                              icon: 'fas fa-language',
                              action: (item) => openLanguageModal(item),
                              title: i18n.t('translate_stores.table.actions.manage_languages'),
                            },
                          ]}
                          color='primary'
                        />
                      </>
                    )}
                  </div>
                )}

                {/* Aba de Relacionamentos */}
                {activeTab === 'relations' && (
                  <div>
                    <div className='d-flex justify-content-between align-items-center mb-6 '>
                      <div>
                        <h4 className='mb-1'>
                          {i18n.t('translate_stores.page_title_relationships')}
                        </h4>
                        <p className='text-muted mb-0'>
                          {i18n.t('translate_stores.page_subtitle_relationships')}
                        </p>
                      </div>
                      {dataAll && dataAll.length > 0 && (
                        <Button
                          text={i18n.t('translate_stores.relations.create_button')}
                          color='primary'
                          icon='fas fa-plus'
                          size='small'
                          click={() => openRelationModal('create')}
                        />
                      )}
                    </div>

                    {/* Linha separadora */}
                    <div className='separator border-gray-200 mb-6'></div>

                    {/* Filtros de relacionamentos */}
                    <div className='d-flex align-items-center justify-content-start mb-4'>
                      <div className='d-flex w-50'>
                        <div className='align-items-end justify-content-start me-5 flex-grow-1'>
                          <span className='align-self-start'>
                            {i18n.t('translate_stores.relations.parent_label')}
                          </span>
                          <Input
                            inputAttr={{
                              type: 'select',
                            }}
                            options={getStoreFilterOptions()}
                            value={filterParentStore}
                            placeholder={i18n.t('translate_stores.relations.parent_placeholder')}
                            search={true}
                            change={(value: any) => {
                              setFilterParentStore(value)
                            }}
                          />
                        </div>
                        <div className='align-items-end justify-content-start me-5 flex-grow-1'>
                          <span className='align-self-start'>
                            {i18n.t('translate_stores.relations.child_label')}
                          </span>
                          <Input
                            inputAttr={{
                              type: 'select',
                            }}
                            options={getStoreFilterOptions()}
                            value={filterChildStore}
                            placeholder={i18n.t('translate_stores.relations.child_placeholder')}
                            search={true}
                            change={(value: any) => setFilterChildStore(value)}
                          />
                        </div>
                      </div>

                      <div
                        className='d-flex align-items-end w-50 justify-content-end h-100'
                        style={{
                          marginTop: '48px',
                        }}
                      >
                        <Button
                          text={i18n.t('translate_stores.filters.filter_button')}
                          color='primary'
                          iconColor='#FFF'
                          icon='fas fa-filter'
                          size='small'
                          horizontalPadding={6}
                          btnAttr={{
                            type: 'button',
                          }}
                          click={filterRelations}
                          btnClass='mb-0 fw-bolder'
                        />
                      </div>
                    </div>

                    {loadingRelations ? (
                      <Loading />
                    ) : storeRelations.length === 0 ? (
                      <div className={styles.emptyState}>
                        <i className='fas fa-sitemap fa-3x'></i>
                        <p>{i18n.t('translate_stores.relations.no_relations')}</p>
                        <p>
                          {i18n.t('translate_stores.relations.click_new') ||
                            'Clique em "Novo Relacionamento" para começar'}
                        </p>
                      </div>
                    ) : (
                      <Datatable
                        data={storeRelations}
                        headers={[
                          {
                            key: String(i18n.t('translate_stores.relations.parent_label')),
                            value: 'parentName',
                            type: 'default',
                          },
                          {
                            key: String(i18n.t('translate_stores.table.id')),
                            value: 'parentId',
                            type: 'default',
                          },
                          {
                            key: String(i18n.t('translate_stores.relations.child_label')),
                            value: 'childName',
                            type: 'default',
                          },
                          {
                            key: String(i18n.t('translate_stores.table.id')),
                            value: 'childId',
                            type: 'default',
                          },
                          {
                            key: String(i18n.t('translate_stores.table.actions')),
                            value: 'acoes',
                            type: '',
                          },
                        ]}
                        options={[
                          // {
                          //   icon: 'fas fa-edit',
                          //   action: (item) => openRelationModal('edit', item),
                          //   title: 'Editar relacionamento',
                          // },
                          {
                            icon: 'fas fa-trash',
                            action: (item) => deleteStoreRelation(item),
                            title: 'Excluir relacionamento',
                            color: 'danger',
                          },
                        ]}
                        color='primary'
                      />
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal de Linguagens */}
      <Modal show={showLanguageModal} onHide={() => setShowLanguageModal(false)} size='lg'>
        <Modal.Header closeButton>
          <Modal.Title>
            {i18n.t('translate_stores.modal.title')} - {selectedStoreName}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='row'>
            <div className='col-12'>
              <p className='text-muted mb-4'>{i18n.t('translate_stores.modal.description')}</p>

              <div className='alert alert-info mb-4'>
                <div className='d-flex'>
                  <i className='fas fa-info-circle me-3 mt-1'></i>
                  <div>
                    <strong>{i18n.t('translate_stores.modal.alert.title')}</strong>{' '}
                    {i18n.t('translate_stores.modal.alert.message')}
                  </div>
                </div>
              </div>

              <div className='row'>
                {storeLanguages.map((language, index) => (
                  <div key={`language-${index}`} className='col-md-6 mb-3'>
                    <div className='form-check form-switch'>
                      <input
                        className='form-check-input'
                        type='checkbox'
                        id={`language-${language.code}`}
                        checked={language.status}
                        onChange={(e) => updateLanguageStatus(language.code, e.target.checked)}
                      />
                      <label className='form-check-label' htmlFor={`language-${language.code}`}>
                        <span className='fw-bold'>{language.name}</span> - {language.description}
                      </label>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            text={i18n.t('translate_stores.modal.buttons.cancel')}
            color='secondary'
            size='small'
            click={() => setShowLanguageModal(false)}
          />
          <Button
            text={i18n.t('translate_stores.modal.buttons.save')}
            color='primary'
            size='small'
            click={saveStoreLanguages}
            disabled={loading}
          />
        </Modal.Footer>
      </Modal>

      {/* Modal de Relacionamentos */}
      <Modal show={showRelationModal} onHide={() => setShowRelationModal(false)} size='lg'>
        <Modal.Header closeButton>
          <Modal.Title>
            {relationModalMode === 'create'
              ? i18n.t('translate_stores.relations.create_title')
              : i18n.t('translate_stores.relations.edit_title')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='row'>
            <div className='col-12 mb-4'>
              <div className='alert alert-info'>
                <div className='d-flex'>
                  <i className='fas fa-info-circle me-3 mt-1'></i>
                  <div>
                    <strong>{i18n.t('translate_stores.relations.create_title')}</strong>
                    <br />
                    {relationModalMode === 'create'
                      ? i18n.t('translate_stores.relations.create_description')
                      : i18n.t('translate_stores.relations.edit_description')}
                  </div>
                </div>
              </div>
            </div>

            <div className='col-md-6 mb-4'>
              <label className='form-label fw-bold'>
                <i className='fas fa-building me-2'></i>
                {i18n.t('translate_stores.relations.parent_label')}
              </label>
              <Input
                inputAttr={{
                  type: 'select',
                }}
                options={getStoreOptions()}
                value={selectedParentStore}
                placeholder={i18n.t('translate_stores.relations.parent_missing')}
                search={true}
                change={(value: any) => setSelectedParentStore(value)}
              />
            </div>

            <div className='col-md-6 mb-4'>
              <label className='form-label fw-bold'>
                <i className='fas fa-store me-2'></i>
                {i18n.t('translate_stores.relations.child_label')}
              </label>
              <Input
                inputAttr={{
                  type: 'select',
                }}
                options={getStoreOptions().filter(
                  (option) => option.value !== selectedParentStore?.value
                )}
                value={selectedChildStore}
                placeholder={i18n.t('translate_stores.relations.child_missing')}
                search={true}
                change={(value: any) => setSelectedChildStore(value)}
              />
            </div>

            {selectedParentStore && selectedChildStore && (
              <div className='col-12'>
                <div className='alert alert-success'>
                  <div className='d-flex'>
                    <i className='fas fa-check-circle me-3 mt-1'></i>
                    <div>
                      <strong>
                        {i18n.t('translate_stores.relations.summary_title') ||
                          'Resumo do relacionamento:'}
                      </strong>
                      <br />
                      <div className='mt-2'>
                        <span className='badge badge-primary me-2'>
                          {i18n.t('translate_stores.relations.parent_label')}
                        </span>
                        <strong>{selectedParentStore.label}</strong>
                      </div>
                      <div className='mt-1'>
                        <span className='badge badge-primary me-2'>
                          {i18n.t('translate_stores.relations.child_label')}
                        </span>
                        <strong>{selectedChildStore.label}</strong>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className='col-12'>
              <div className='card'>
                <div className='card-body p-3'>
                  <h6 className='card-title mb-2'>
                    <i className='fas fa-lightbulb me-2'></i>
                    {i18n.t('translate_stores.relations.tips_title')}
                  </h6>
                  <ul className='mb-0 small text-muted'>
                    <li>{i18n.t('translate_stores.relations.tip_parent_multiple')}</li>
                    <li>{i18n.t('translate_stores.relations.tip_child_single')}</li>
                    <li>{i18n.t('translate_stores.relations.tip_all_available')}</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            text={i18n.t('translate_stores.relations.cancel')}
            color='secondary'
            size='small'
            click={() => setShowRelationModal(false)}
          />
          <Button
            text={
              relationModalMode === 'create'
                ? i18n.t('translate_stores.relations.create_button')
                : i18n.t('translate_stores.relations.save_changes')
            }
            color='primary'
            size='small'
            click={relationModalMode === 'create' ? createStoreRelation : updateStoreRelation}
            disabled={loading || !selectedParentStore || !selectedChildStore}
            loading={loading}
          />
        </Modal.Footer>
      </Modal>
    </>
  )
}

const TranslatePluginspace: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {
            title: i18n.t('translate_stores.breadcrumb.dashboard'),
            path: 'dashboard',
            isActive: true,
          },
          {
            title: i18n.t('translate_stores.breadcrumb.translate_stores'),
            path: 'translate-pluginspace',
            isActive: true,
          },
        ]}
      >
        {i18n.t('translate_stores.page_title')}
      </PageTitle>
      <TranslatePluginspaceContent />
    </>
  )
}

export {TranslatePluginspace}
